import React, { useEffect, useState, useRef } from "react";
import { MdFilterAlt, MdClose } from "react-icons/md";
import axios from "axios";

// 1. Keep only actual Bootstrap components here
import { Modal, Card, Table, Tab, Tabs } from "react-bootstrap";

import logo from "../images/amotive-orange-revert-white-orange-symbol.png";

// 2. Keep the Chart components here
import { 
  ResponsiveContainer, 
  PieChart, 
  Pie, 
  Cell, 
  Legend, 
  Tooltip 
} from 'recharts';

const Dettagli = ({ showModal, handleCloseModal }) => {
    // ... rest of your code
  // ... (TUTTA LA TUA LOGICA DELLO STATO E FETCHDATA RIMANE INVARIATA)
  const [tpData, setTpData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [tpPieData, setTpPieData] = useState([]);
  const [tpTipoClienteData, setTpTipoClienteData] = useState([]);
  const [tpClienteData, setTpClienteData] = useState([]);
  const [tpArticoloData, setTpArticoloData] = useState([]);
  const [tpPrecodiceData, setTpPrecodiceData] = useState([]);
  const [tpFamigliaData, setTpFamigliaData] = useState([]);
  const [visiteOnline, setVisiteOnline] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });
  const articleRefs = useRef({});

  const COLORS = ["#f16f24", "#ff8c4a", "#d45511", "#216583", "#444", "#666"];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("./mancata_vendita_dashboard.json");
        const tpJsonData = res.data.AR.data;
        const tpJsonData2 = res.data.AR.visite;
        const tpJsonData3 = Array.isArray(res.data.TP.ordini) ? res.data.TP.ordini : [];

        const tpTipoCliGroups = tpJsonData.tipo_cliente.reduce((acc, curr) => {
          const tipoCli = curr.tipo_cli;
          const ricerche = parseInt(curr.numero_ricerche_articolo, 10);
          if (!acc[tipoCli]) acc[tipoCli] = 0;
          acc[tipoCli] += ricerche;
          return acc;
        }, {});

        const tpPieChartData = Object.entries(tpTipoCliGroups).map(([tipoCli, count]) => ({
          name: tipoCli,
          count: count,
        }));

        const tpPrecodiceGroups = tpJsonData.articolo.reduce((acc, curr) => {
          const precodice = curr.precodice;
          const ricerche = parseInt(curr.numero_ricerche_articolo, 10);
          const nettoTotale = curr.netto_totale
            ? parseFloat(curr.netto_totale.replace(/[^0-9,.-]+/g, "").replace(",", "."))
            : 0;
          if (!acc[precodice]) acc[precodice] = { numero_ricerche_articolo: 0, netto_totale: 0 };
          acc[precodice].numero_ricerche_articolo += ricerche;
          acc[precodice].netto_totale += nettoTotale;
          return acc;
        }, {});

        const tpOrdiniGroups = tpJsonData3.reduce((acc, curr) => {
          const precodice = curr.precodice;
          const totalQuantity = curr.total_quantity ? parseFloat(curr.total_quantity.replace(",", ".")) : 0;
          const totalValue = curr.total_value ? parseFloat(curr.total_value.replace(",", ".")) : 0;
          if (!acc[precodice]) acc[precodice] = { total_quantity: 0, total_value: 0 };
          acc[precodice].total_quantity += totalQuantity;
          acc[precodice].total_value += totalValue;
          return acc;
        }, {});

        const tpPrecodiceChartData = Object.entries(tpPrecodiceGroups).map(([precodice, data]) => {
          const ordiniData = tpOrdiniGroups[precodice] || { total_quantity: 0, total_value: 0 };
          return {
            precodice,
            numero_ricerche_articolo: data.numero_ricerche_articolo,
            netto_totale: data.netto_totale,
            total_quantity: ordiniData.total_quantity,
            total_value: ordiniData.total_value,
          };
        });

        const tpFamigliaGroups = tpJsonData.articolo.reduce((acc, curr) => {
          const famiglia = curr.famiglia;
          const ricerche = parseInt(curr.numero_ricerche_articolo, 10);
          const nettoTotale = parseFloat(curr.netto_totale.replace(/[^0-9,.-]+/g, "").replace(",", "."));
          if (!acc[famiglia]) acc[famiglia] = { numero_ricerche_articolo: 0, netto_totale: 0 };
          acc[famiglia].numero_ricerche_articolo += ricerche;
          acc[famiglia].netto_totale += nettoTotale;
          return acc;
        }, {});

        const tpFamigliaChartData = Object.entries(tpFamigliaGroups).map(([famiglia, data]) => ({
          famiglia,
          numero_ricerche_articolo: data.numero_ricerche_articolo,
          netto_totale: data.netto_totale,
        }));

        setTpPieData(tpPieChartData);
        setTpTipoClienteData(tpJsonData.tipo_cliente);
        setTpClienteData(tpJsonData.cliente);
        setTpArticoloData(tpJsonData.articolo);
        setTpPrecodiceData(tpPrecodiceChartData);
        setTpFamigliaData(tpFamigliaChartData);
        setVisiteOnline(tpJsonData2.visite_online);
      } catch (error) {
        setIsError(true);
      }
    };
    fetchData();
  }, []);

 const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
      const parseEuroToNumber = (amount) => typeof amount === "string" ? parseFloat(amount.replace(/[^0-9,.-]+/g, "").replace(",", ".")) : amount || 0;

  const handleSort = (key, data, setData) => {
    let direction = "desc";
    if (sortConfig.key === key && sortConfig.direction === "desc") direction = "asc";
    const sortedData = [...data].sort((a, b) => {
      let aValue = key === "netto_totale" ? parseEuroToNumber(a[key]) : a[key];
      let bValue = key === "netto_totale" ? parseEuroToNumber(b[key]) : b[key];
      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setData(sortedData);
  };

  const handleArticleClick = (articolo) => {
    if (articleRefs.current[articolo.articolo]) {
      articleRefs.current[articolo.articolo].scrollIntoView({ behavior: "smooth" });
    }
  };

  // HEADER MODERNIZZATO
  const renderSortableHeader = (label, key, data, setData, isOrange = true) => (
    <th
      onClick={() => handleSort(key, data, setData)}
      style={{ 
        cursor: "pointer", 
        color: isOrange ? "#f16f24" : "#ffffff",
        fontSize: '0.85rem',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        borderBottom: '2px solid #333'
      }}
      className="bg-transparent py-3"
    >
      {label} {sortConfig.key === key && (sortConfig.direction === "asc" ? "↑" : "↓")}
    </th>
  );

  return (
    <>
      <style>{`
        .modern-modal .modal-content {
          color: #f5f6f8;
          background:
            radial-gradient(circle at 0% 0%, rgba(241,111,36,0.18), transparent 34%),
            linear-gradient(145deg, rgba(37,40,47,0.94), rgba(18,20,25,0.97));
          border: 1px solid rgba(255,255,255,0.11);
          border-radius: 24px;
          overflow: hidden;
          box-shadow:
            0 32px 80px rgba(0,0,0,0.55),
            inset 0 1px 0 rgba(255,255,255,0.08);
          backdrop-filter: blur(8px) saturate(115%);
          -webkit-backdrop-filter: blur(8px) saturate(115%);
        }

        .modern-modal .modal-body {
          overflow-y: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .modern-modal .modal-body::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }

        .modern-modal + .modal-backdrop,
        .modal-backdrop.show {
          background: #07090d !important;
          opacity: 0.88 !important;
        }
        .modern-modal .modern-card {
          background: rgba(255, 255, 255, 0.03) !important;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.05) !important;
          border-radius: 15px !important;
          transition: transform 0.3s ease;
          margin: 10px;
        }
        .modern-modal .modern-card:hover {
          background: rgba(255, 255, 255, 0.05) !important;
        }
        .modern-modal .nav-tabs { border: none !important; margin-bottom: 20px; gap: 10px; }
        .modern-modal .nav-link { 
          color: #888 !important; 
          border: none !important; 
          border-radius: 10px !important; 
          padding: 8px 20px !important;
          background: rgba(255,255,255,0.02) !important;
        }
        .modern-modal .nav-link.active { 
          background: #f16f24 !important; 
          color: white !important;
          box-shadow: 0 4px 15px rgba(241, 111, 36, 0.3);
        }
        .modern-modal .custom-table td { 
          vertical-align: middle; 
          border-color: #222 !important; 
          padding: 12px 8px !important;
          font-size: 0.9rem;
        }
        .modern-modal .scroll-container { scrollbar-width: none; -ms-overflow-style: none; }
        .modern-modal .scroll-container::-webkit-scrollbar { display: none; width: 0; height: 0; }
        
        .modern-modal .stat-value {
          background: linear-gradient(to right, #f16f24, #ff8c4a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-weight: 800;
        }
      `}</style>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="xl"
        className="modern-modal"
      >
        <Modal.Header className="border-0 pb-0 d-flex justify-content-between align-items-center" style={{padding: '2rem'}}>
          <Modal.Title className="fw-bold text-white" style={{fontSize: '1.8rem'}}>
             Analisi <span style={{color: '#f16f24'}}>Mancata Vendita</span>
          </Modal.Title>
          <div onClick={handleCloseModal} style={{cursor: 'pointer', color: '#888'}}><MdClose size={30}/></div>
        </Modal.Header>

        <Modal.Body className="p-4">
          <div className="row g-4">
            {/* PIE CHART CARD */}
            <div className="col-lg-7">
              <Card className="modern-card h-100 m-0">
                <Card.Body>
                  <Card.Title className="text-white-50 small mb-4 uppercase">Distribuzione Ricerche</Card.Title>
                  <ResponsiveContainer width="100%" height={350}>
                    <PieChart>
                      <Pie
                        data={tpPieData}
                        dataKey="count"
                        nameKey="name"
                        cx="50%" cy="50%"
                        innerRadius={80}
                        outerRadius={120}
                        paddingAngle={5}
                      >
                        {tpPieData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip 
                        contentStyle={{backgroundColor: '#1a1a1a', border: '1px solid #333', borderRadius: '10px'}}
                        itemStyle={{color: '#fff'}}
                      />
                      <Legend verticalAlign="bottom" height={36}/>
                    </PieChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </div>

            {/* VISITE CARD */}
            <div className="col-lg-5">
              <Card className="modern-card h-100 m-0 d-flex justify-content-center align-items-center text-center p-4">
                <Card.Body>
                   <h6 className="text-white-50 text-uppercase mb-3">Visite Senza Acquisto</h6>
                   <h1 className="stat-value" style={{fontSize: '6rem'}}>{visiteOnline}</h1>
                   <p className="text-white-50 small mt-3">Utenti che hanno consultato il catalogo nell'ultimo periodo senza finalizzare ordini.</p>
                </Card.Body>
              </Card>
            </div>

            {/* TABLES SECTION */}
            <div className="col-12">
              <Card className="modern-card m-0">
                <Card.Body className="p-4">
                  <Tabs defaultActiveKey="cliente" id="modern-tabs">
                    <Tab eventKey="cliente" title="Dettaglio Clienti">
                      <div className="scroll-container" style={{maxHeight: '400px', overflowY: 'auto'}}>
                        <Table responsive className="custom-table text-white border-0">
                          <thead>
                            <tr>
                              <th className="bg-transparent text-white-50 border-0">Ragione Sociale</th>
                              {renderSortableHeader("Ricerche", "numero_ricerche_articolo", tpClienteData, setTpClienteData)}
                              {renderSortableHeader("Netto Totale", "netto_totale", tpClienteData, setTpClienteData)}
                            </tr>
                          </thead>
                          <tbody>
                            {tpClienteData.map((cliente, index) => (
                              <tr key={index} className="border-0">
                                <td className="bg-transparent text-white fw-bold border-0">{cliente.ragione_sociale}</td>
                                <td className="bg-transparent text-warning border-0">{cliente.numero_ricerche_articolo}</td>
                                <td className="bg-transparent text-warning border-0">{formatToEuro(cliente.netto_totale)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Tab>

                    <Tab eventKey="articolo" title="Dettaglio Articoli">
                       <div className="scroll-container" style={{maxHeight: '400px', overflowY: 'auto'}}>
                        <Table responsive className="custom-table text-white border-0">
                          <thead>
                            <tr>
                              <th className="bg-transparent text-white-50 border-0">Articolo</th>
                              {renderSortableHeader("Precodice", "precodice", tpArticoloData, setTpArticoloData, false)}
                              <th className="bg-transparent text-white-50 border-0">Famiglia</th>
                              {renderSortableHeader("Ricerche", "numero_ricerche_articolo", tpArticoloData, setTpArticoloData)}
                              {renderSortableHeader("Netto", "netto_totale", tpArticoloData, setTpArticoloData)}
                            </tr>
                          </thead>
                          <tbody>
                            {tpArticoloData.map((art, index) => (
                              <tr key={index}>
                                <td className="bg-transparent text-white border-0">{art.articolo}</td>
                                <td className="bg-transparent text-white-50 border-0">{art.precodice}</td>
                                <td className="bg-transparent text-white-50 border-0">{art.famiglia}</td>
                                <td className="bg-transparent text-warning border-0">{art.numero_ricerche_articolo}</td>
                                <td className="bg-transparent text-warning border-0">{formatToEuro(art.netto_totale)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Tab>
                    
                    <Tab eventKey="precodice" title="Performance Precodici">
                       <div className="scroll-container" style={{maxHeight: '400px', overflowY: 'auto'}}>
                         <Table responsive className="custom-table text-white border-0">
                            <thead>
                               <tr>
                                  <th className="bg-transparent text-white border-0">Codice</th>
                                  <th className="bg-transparent text-white-50 border-0">Ricerche MV</th>
                                  <th className="bg-transparent text-white-50 border-0">Netto MV</th>
                                  <th className="bg-transparent text-white-50 border-0">Netto Ordini</th>
                                  <th className="bg-transparent text-warning border-0">Totale</th>
                                  <th className="bg-transparent text-warning border-0">Disponibilità</th>
                               </tr>
                            </thead>
                            <tbody>
                               {tpPrecodiceData.map((p, i) => (
                                 <tr key={i}>
                                    <td className="bg-transparent fw-bold border-0" style={{color: '#f16f24'}}>{p.precodice}</td>
                                    <td className="bg-transparent border-0">{p.numero_ricerche_articolo}</td>
                                    <td className="bg-transparent border-0 text-white-50">{formatToEuro(p.netto_totale)}</td>
                                    <td className="bg-transparent border-0 text-white-50">{formatToEuro(p.total_value)}</td>
                                    <td className="bg-transparent text-warning border-0 fw-bold">{formatToEuro(p.total_value + p.netto_totale)}</td>
                                    <td className="bg-transparent border-0">
                                       <span className="badge rounded-pill bg-dark border border-secondary px-3 py-2">
                                          {(100 - (p.numero_ricerche_articolo / (p.total_quantity + p.numero_ricerche_articolo) * 100)).toFixed(1)}%
                                       </span>
                                    </td>
                                 </tr>
                               ))}
                            </tbody>
                         </Table>
                       </div>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0 justify-content-center pb-4">
          <img src={logo} alt="Amotive Logo" style={{ width: "140px", opacity: 0.8 }} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Dettagli;